// @flow
import React from 'react';
import styled from 'styled-components';

const ToastCloseButton = styled.button`
  background: transparent;
  border: none;
  color: black;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  outline: none;
  padding: 0;
  opacity: 0.3;
  transition: 0.3s ease;
  align-self: flex-start;

  &:hover,
  &:focus {
    opacity: 1;
  }
`;

type SidebarDismissBypassingCloseButtonProps = {
  closeToast?: any => any,
};

/**
 * A custom close button to provide to react-toastify that includes the
 * `data-bypass-dismiss-sidebar` prop so that when the toast is dismissed, the sidebar doesn't
 * disappear, losing transient state in the sidebar.
 *
 * Styles and markup taken from node_modules/react-toastify/src/DefaultCloseButton.js
 */
const SidebarDismissBypassingCloseButton = ({
  closeToast,
}: SidebarDismissBypassingCloseButtonProps) => (
  <ToastCloseButton
    aria-label="close"
    data-bypass-dismiss-sidebar
    onClick={closeToast}
    type="button"
  >
    ✖
  </ToastCloseButton>
);

SidebarDismissBypassingCloseButton.defaultProps = {
  closeToast: undefined,
};

export default SidebarDismissBypassingCloseButton;
